module.exports = __webpack_public_path__ + "static/media/logout.c42d6838.svg";